import { Component, Input, OnChanges } from '@angular/core';
import { about_ketto, how_it_works, hiw_non_medical } from './story.object';

@Component({
  selector: 'app-story-footer',
  templateUrl: './story-footer.component.html',
  styleUrls: ['./story-footer.component.scss']
})
export class StoryFooterComponent implements OnChanges {

  @Input() beneficiary;
  @Input() hospital;
  @Input() manager;
  @Input() nonMedical;
  aboutContent = about_ketto;
  howItWorksContent = {
    patient: '',
    hospital: '',
    beneficiary: '',
    manager: ''
  };
  howItWorksArray;
  constructor() { }

  ngOnChanges() {
    this.nonMedical ? this.setFooterContent('NGO Partner') : this.setFooterContent('Patient');
  }

  setFooterContent(beneficiary_name) {
    this.howItWorksContent = {
      patient: this.beneficiary || 'Patient',
      hospital: this.hospital || '',
      beneficiary: this.beneficiary || beneficiary_name,
      manager: this.manager || 'Fundraiser Manager',
    };
    this.howItWorksArray = this.nonMedical ? hiw_non_medical(this.howItWorksContent) : how_it_works(this.howItWorksContent);
  }

}
